import { Controller } from "@hotwired/stimulus"

// Drag-and-drop for the schedule PDF. The file input stays the source of truth so the
// form submits normally with JS off — this only makes the drop target feel like one.
export default class extends Controller {
  static targets = ["dropzone", "input", "prompt", "hint"]

  browse() {
    this.inputTarget.click()
  }

  dragover(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("border-tie", "bg-tie-50")
  }

  dragleave() {
    this.#clearHighlight()
  }

  drop(event) {
    event.preventDefault()
    this.#clearHighlight()

    const [file] = event.dataTransfer.files
    if (!file) return

    if (file.type !== "application/pdf") {
      this.hintTarget.textContent = "That isn't a PDF. Print the schedule to PDF and try again."
      return
    }

    const transfer = new DataTransfer()
    transfer.items.add(file)
    this.inputTarget.files = transfer.files
    this.selected()
  }

  selected() {
    const [file] = this.inputTarget.files
    if (!file) return

    this.promptTarget.textContent = file.name
    this.hintTarget.textContent = `${(file.size / 1048576).toFixed(1)} MB — ready to convert`
    this.dropzoneTarget.classList.add("border-tie")
  }

  #clearHighlight() {
    this.dropzoneTarget.classList.remove("border-tie", "bg-tie-50")
  }
}
